var niTrackEvent = function niTrackEvent(data) {
  var _window, _window$ni, _window$ni$uiEvents;

  (_window = window) === null || _window === void 0 ? void 0 : (_window$ni = _window.ni) === null || _window$ni === void 0 ? void 0 : (_window$ni$uiEvents = _window$ni.uiEvents) === null || _window$ni$uiEvents === void 0 ? void 0 : _window$ni$uiEvents.trackEvent(data);
};
var trackShowMore = function trackShowMore(data) {
  var _window2, _window2$ni, _window2$ni$uiEvents;

  (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$ni = _window2.ni) === null || _window2$ni === void 0 ? void 0 : (_window2$ni$uiEvents = _window2$ni.uiEvents) === null || _window2$ni$uiEvents === void 0 ? void 0 : _window2$ni$uiEvents.trackShowMore(data);
};

export { niTrackEvent as n, trackShowMore as t };
